import {Component, Input} from '@angular/core';
import {FormBuilder, FormGroup} from '@angular/forms';
import {MatDialogRef} from '@angular/material';

/**------------------------------------------------------
 * Component for adding EXTRA FEE FormGroup
 *------------------------------------------------------*/

@Component({
  selector: 'extra-fee',
  template: `
        <div [formGroup]='fee' style="display:flex;">
            <div class='row__input' style="width: 20%; text-align: center">
              <input formControlName='description'>
            </div>
            <div class='row__input' style="width: 20%; text-align: center">
              <input formControlName='amount' (change)='countVat(fee)'>
            </div>
            <div class='row__input' style="width: 20%; text-align: center">
              <input formControlName='vatPercent' (change)='countVat(fee)'>
            </div>
            <div class='row__input' style="width: 20%; text-align: center">
              <input formControlName='vatValue' style='text-align: right'>
            </div>
            <div class='row__input' style="width: 20%; text-align: center">
              <input formControlName='total'>
            </div>
        </div>
        `,
  styles: [`
        input:not([type]), input[type='email'], input[type='number'], input[type='password'], input[type='tel'], input[type='url'], input[type='text']{
            width: 100%;
        }

    `]
})

export class ExtraFeeComponent {
  @Input('group') public fee: FormGroup;
  @Input('count') public count: number;
  constructor(public dialogRef: MatDialogRef<ExtraFeeComponent>, private _fb: FormBuilder) {
  }

  correctFloat(val) {
    let result;
    if (typeof val === 'string') {
      result = Number(val.replace(/,/g , '.')).toFixed(2);
    } else {
      result = Number(parseFloat(val)).toFixed(2);
    }
    return parseFloat(result);
  }

  countVat(feeGroup) {
    const amount = this.correctFloat(feeGroup['controls']['amount'].value);
    const percent = this.correctFloat(feeGroup['controls']['vatPercent'].value);
    const vat = amount / 100 * percent;
    const total = amount + vat;
    feeGroup.controls['vatValue'].patchValue(Number(vat).toFixed(2));
    feeGroup.controls['total'].patchValue(Number(total).toFixed(2));
  }

}



// WEBPACK FOOTER //
// ./src/app/components/atoms/extra-fee/extra-fee.component.ts